import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import {AuthGuardService}from'./services/auth-guard.service';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import * as firebase from 'firebase';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IonicSelectableModule } from 'ionic-selectable';
import { ChartsModule } from 'ng2-charts';
import 'chartjs-plugin-zoom';
import {ModalUploadPageModule}from'./modal-upload/modal-upload.module'
import {ModalAprobacionPageModule} from './modal-aprobacion/modal-aprobacion.module'
import {ModalActividadesTrabajadorPageModule} from './modal-actividades-trabajador/modal-actividades-trabajador.module'
import {ModalHerramientasYControlesPageModule} from './modal-herramientas-ycontroles/modal-herramientas-ycontroles.module'
import {ModalAsignacionInicialPageModule} from './modal-asignacion-inicial/modal-asignacion-inicial.module'

import { CalendarModule } from 'ion2-calendar';



import {TimelineComponent} from './timeline/timeline.component'



var config = {
  apiKey: "AIzaSyCR9JzAvg7blumth9rpCcxgckHSDr6M7MA",
  authDomain: "gt-ptw.firebaseapp.com",
  databaseURL: "https://gt-ptw.firebaseio.com",
  projectId: "gt-ptw",
  storageBucket: "gt-ptw.appspot.com",
  messagingSenderId: "526164954130",
  appId: "1:526164954130:web:598790b2a4b378fb1c5ccb"
};

firebase.initializeApp(config);

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule,
    IonicSelectableModule,
    ChartsModule,
    ModalUploadPageModule,
    ModalAprobacionPageModule,
    CalendarModule,
    ModalAsignacionInicialPageModule,
    ModalActividadesTrabajadorPageModule,
    ModalHerramientasYControlesPageModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    TimelineComponent,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
